import React, { cloneElement, HTMLAttributes } from "react";

import styles from "../../styles/Icon.css";

interface IconStyleProps {
  size?: number;
  color?: string;
  noColor?: boolean;
  clickable?: boolean;
}

type IconWrapperProps = IconStyleProps & Omit<any, "ref"> & HTMLAttributes<any>;

export type IconProps = Omit<IconWrapperProps, "children" | "noColor">;

const IconElement: any = (props: IconWrapperProps) => {
  let { size, color, noColor, clickable, ...rest } = props;

  if (props.children) {
    return cloneElement(props.children as any, {
      ...rest,
      children: (props.children as any)?.props?.children,
      className: `${styles.icon} ${props.className || ""} ${
        noColor ? styles.iconNoColor : ""
      }`,
      style: {
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        color: color,
        stroke: color,
        cursor: clickable ? "pointer" : props.style?.cursor,
        ...props.style,
      },
    });
  }
  return null;
};

type SvgIcon = JSX.IntrinsicElements["svg"];
export function newIcon<T = unknown>(
  icon: SvgIcon | ((props: T) => SvgIcon),
  noColor?: boolean,
  noForwardProps: (keyof T)[] = []
) {
  return (props: IconProps & T) => {
    const forward = { ...props };
    noForwardProps.forEach((prop) => delete forward[prop]);
    return (
      <IconElement {...forward}>
        {icon instanceof Function ? icon(props) : icon}
      </IconElement>
    );
  };
}

export type Icon = ReturnType<typeof newIcon>;

export default Icon;
